import { render, staticRenderFns } from "./ShopCouponPreview.vue?vue&type=template&id=5f3ba9d1&scoped=true"
import script from "./ShopCouponPreview.vue?vue&type=script&lang=js"
export * from "./ShopCouponPreview.vue?vue&type=script&lang=js"
import style0 from "./ShopCouponPreview.vue?vue&type=style&index=0&id=5f3ba9d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ba9d1",
  null
  
)

export default component.exports